// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import mock from '../../../services/mock'

/* istanbul ignore next  */
mock.onGet('/users/getData').reply(config => {
    // eslint-disable-next-line object-curly-newline
    let dataUsers = [
        {
            id: 1,
            full_name: 'Manuel Raúl Gonzalez Gil',
            userCode: 44331,
            role: 'administrador',
            status: 'active',
            avatar: "",
            phone: 3312345678,
            email: "lruvalcaba@email.com"
        },
        {
            id: 2,
            full_name: 'Abril Gonzalez Ayon',
            userCode: 44331,
            role: 'administrador',
            status: 'inactive',
            avatar: "/static/media/1.6a7d13c0.png",
            phone: 3312345678,
            email: "lruvalcaba@email.com"
        },
        {
            id: 3,
            full_name: 'Aaron Miramontes Berumen',
            userCode: 44331,
            role: 'administrador',
            status: 'active',
            avatar: "",
            phone: 3312345678,
            email: "lruvalcaba@email.com"
        },
        {
            id: 4,
            full_name: 'Aaron Miramontes Berumen',
            userCode: 44331,
            role: 'administrador',
            status: 'active',
            avatar: "",
            phone: 3312345678,
            email: "lruvalcaba@email.com"
        },
        {
            id: 5,
            full_name: 'Aaron Miramontes Berumen',
            userCode: 44331,
            role: 'administrador',
            status: 'active',
            avatar: "",
            phone: 3312345678,
            email: "lruvalcaba@email.com"
        },
        {
            id: 6,
            full_name: 'Aaron Miramontes Berumen',
            userCode: 44331,
            role: 'administrador',
            status: 'active',
            avatar: "",
            phone: 3312345678,
            email: "lruvalcaba@email.com"
        },
        {
            id: 7,
            full_name: 'Aaron Miramontes Berumen',
            userCode: 44331,
            role: 'administrador',
            status: 'active',
            avatar: "",
            phone: 3312345678,
            email: "lruvalcaba@email.com"
        },
        {
            id: 8,
            full_name: 'Aaron Miramontes Berumen',
            userCode: 44331,
            role: 'administrador',
            status: 'active',
            avatar: "",
            phone: 3312345678,
            email: "lruvalcaba@email.com"
        },
        {
            id: 9,
            full_name: 'Aaron Miramontes Berumen',
            userCode: 44331,
            role: 'administrador',
            status: 'active',
            avatar: "",
            phone: 3312345678,
            email: "lruvalcaba@email.com"
        },
        {
            id: 10,
            full_name: 'Aaron Miramontes Berumen',
            userCode: 44331,
            role: 'administrador',
            status: 'active',
            avatar: "",
            phone: 3312345678,
            email: "lruvalcaba@email.com"
        },
        {
            id: 11,
            full_name: 'Aaron Miramontes Berumen',
            userCode: 44331,
            role: 'administrador',
            status: 'active',
            avatar: "",
            phone: 3312345678,
            email: "lruvalcaba@email.com"
        }
    ]

    return [
        200,
        {
            users: dataUsers
        }
    ]
})


export const getData = createAsyncThunk('users/getData', async params => {

    const response = await axios.get('/users/getData')
    return {
        params,
        data: response.data.users,
        total: response.data.users.length
    }
})

export const addUser = createAsyncThunk('users/addUser', async (user, { dispatch, getState }) => {
    let result = await axios.post('/apps/users/add-user', user)
    // await dispatch(getData(getState().users.params))
    // let result = true
    return result
})

export const updateUser = createAsyncThunk('users/updateUser', async (user, { dispatch, getState }) => {
    let result = await axios.post('/apps/users/update-user', user)
    // await dispatch(getData(getState().users.params))
    // let result = false
    return result
})

export const deleteUser = createAsyncThunk('users/deleteUser', async (id, { dispatch, getState }) => {
    await axios.delete('/apps/users/delete', { id })
    await dispatch(getData(getState().users.params))
    return id
})

export const getTotalUsers = createAsyncThunk('users/getTotalUsers', async () => {
    // const response = await axios.get('/api/users/getTotalUsers')
    const responseDummy = {
        data: {
            totalUsers: 1200,
            activeUsers: 980,
            inactiveUsers: 400
        }
    }
    return responseDummy.data
})

export const getRoles = createAsyncThunk('appUsers/getRoles', async () => {
    // const response = await axios.get('/api/users/getRoles')
    const roleOptions = [
        { value: '', label: 'Seleccionar rol' },
        { value: 'administrador', label: 'Administrador' },
        { value: 'author', label: 'Author' },
        { value: 'editor', label: 'Editor' },
        { value: 'maintainer', label: 'Maintainer' },
        { value: 'subscriber', label: 'Subscriber' }
    ]
    return roleOptions
})


export const usersSlice = createSlice({
    name: 'users',
    initialState: {
        data: [],
        total: 1,
        params: {},
        totalUsers: 0,
        activeUsers: 0,
        inactiveUsers: 0,
        roles: []
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.params = action.payload.params
                state.total = action.payload.total
            })
            .addCase(getTotalUsers.fulfilled, (state, action) => {
                state.totalUsers = action.payload.totalUsers
                state.activeUsers = action.payload.activeUsers
                state.inactiveUsers = action.payload.inactiveUsers
            })
            .addCase(getRoles.fulfilled, (state, action) => {
                state.roles = action.payload
            })
    }
})

export default usersSlice.reducer
